// Select all elements where the font might be different
const elements = document.querySelectorAll('body *');

// Iterate through each element to check its font weight and font family
elements.forEach(element => {
  // Get the computed style of the element
  const style = window.getComputedStyle(element);
  
  // Extract the font family from the computed style
  const fontFamily = style.fontFamily;
  
  // Extract the font weight from the computed style
  const fontWeight = style.fontWeight;
  
  // Log the element and its font details to the console
  console.log(`Element: ${element.tagName}, Font Family: ${fontFamily}, Font Weight: ${fontWeight}`);
});
